import clsx from 'clsx';
import { useTranslator } from '@gandi/translate';
import { Base } from '../../Base';
import { SrOnly } from '../../Helper';
import Svg from '../../Svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "CloseButton-root_gNLnp",
  "icon": "CloseButton-icon_1WFKH"
};
function CloseButton({
  theme = 'green',
  label: labelProps,
  className,
  classes,
  ...extraProps
}) {
  const {
    __
  } = useTranslator();
  const classOf = key => classes?.[key] ?? '';
  const label = labelProps || __('Close');
  return /*#__PURE__*/_jsxs(Base, {
    tagName: "button",
    type: "button",
    color: theme,
    border: "none",
    "aria-label": label,
    className: clsx(styles.root, classOf('root'), className),
    ...extraProps,
    children: [/*#__PURE__*/_jsx(Svg, {
      name: "cross",
      focusable: "false",
      className: clsx(styles.icon, classOf('icon'))
    }), /*#__PURE__*/_jsx(SrOnly, {
      children: label
    })]
  });
}
export default CloseButton;